import React from 'react';
import './estilo.scss';
import profile from '../../assets/profile.jpeg'
import 'materialize-css/dist/css/materialize.min.css'



function Profile() {
    return (
        <section className="profile-container container">
            <div>
                <img className="profile-img" src={profile} alt="profile" />
                <h1 className="profile-title-name">Felippe Leme</h1>
                <h2 className="profile-title-role">FullStack Developer</h2>
            </div>
        </section>
    );
}


export default Profile;
